import FormCard from "@/components/flowbite/forms/form-card";
import FormTitle from "@/components/flowbite/forms/form-title";
import { EmailInbox } from "@/components/icons/email-inbox.deprecated";
import { dictionaries } from "@/dictionaries/content";

const SuccessCard = () => {
  return (
    <FormCard classNames="w-[424px] flex flex-col gap-[34px]">
      <div className="flex w-full justify-center">
        <EmailInbox />
      </div>

      <FormTitle subTitle={dictionaries.forgotPassword.sendSuccess.subTitle}>
        {dictionaries.forgotPassword.sendSuccess.title}
      </FormTitle>
    </FormCard>
  );
};

export default SuccessCard;
